import { z } from "zod";

import { apiPost } from "../lib/api";

export const DispatchResponseSchema = z.object({
  call_id: z.string().uuid(),
  room_name: z.string(),
  livekit_url: z.string(),
  operator_access_token: z.string(),
  expires_at: z.string(),
  dispatched_at: z.string(),
});
export type DispatchResponse = z.infer<typeof DispatchResponseSchema>;

export function dispatchEngagement(
  engagementId: string,
  targetPhoneE164: string,
): Promise<DispatchResponse> {
  return apiPost(
    `/api/engagements/${engagementId}/dispatch`,
    DispatchResponseSchema,
    { target_phone_e164: targetPhoneE164 },
  );
}

/**
 * Build a LiveKit Meet URL that auto-joins the given room.
 *
 * meet.livekit.io takes the room URL and token as query parameters —
 * which means the token ends up in browser history and the Meet
 * origin's referer headers. We mitigate by:
 *   - Minting the token with a short TTL (default 15 min, set in
 *     `Settings.livekit_token_ttl_seconds` on the backend)
 *   - Scoping the grants to the single room (no admin / record / cross-room)
 *   - Recommending operators close the Meet tab after the call ends
 * A future iteration should serve our own /live-calls/{id}/monitor
 * page so the token never leaves our origin.
 */
export function buildLiveKitMeetUrl(livekitUrl: string, token: string): string {
  const params = new URLSearchParams({
    liveKitUrl: livekitUrl,
    token,
  });
  return `https://meet.livekit.io/custom?${params.toString()}`;
}
